<div
    class="purchase-done"
    appLinkify
    [linkConfigPath]="i18nBasePath + '.linkConfigs'">
    <div class="container">
        <div
            nz-row
            nzGutter="30"
            nzAlign="middle"
            class="purchase__row">
            <div
                nz-col
                nzXs="12"
                class="purchase__info">
                <div class="purchase-done__icon">
                    <svg-icon-sprite src="purchase-done"></svg-icon-sprite>
                </div>

                <div
                    class="purchase__heading"
                    [innerHTML]="wts.getI18nLabel(i18nBasePath, 'title') | sanitizeHtml"></div>

                <div
                    class="purchase__descr"
                    [innerHTML]="wts.getI18nLabel(i18nBasePath, 'descr') | sanitizeHtml"></div>

                <div
                    class="purchase__descr"
                    [innerHtml]="wts.getI18nLabel(i18nBasePath, 'support.descr') | sanitizeHtml"></div>

                <button
                    nz-button
                    nzSize="large"
                    nzType="primary"
                    class="purchase-done__btn"
                    [innerHtml]="wts.getI18nLabel(i18nBasePath, 'actions.proceedToPortfolio.label') | sanitizeHtml"></button>
            </div>

            <div
                nz-col
                nzXs="12"
                class="purchase__summary">
                <app-summary
                    [entity]="cart$ | async"
                    [numberOfShares]="numberOfShares$ | async"
                    [purchaseStart]="purchaseStart$ | async"></app-summary>
            </div>
        </div>
    </div>
</div>
